import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Realisations from '../components/Realisations';
import Testimonials from '../components/Testimonials';
import Partners from '../components/Partners';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import StructuredData from '../components/StructuredData';

export default function Home() {
  return (
    <>
      <SEOHead
        title="SOCLIMATE | Climatisation, pompe à chaleur et ventilation"
        description="SOCLIMATE vous accompagne pour l’installation, l’entretien et le dépannage de climatisation, pompe à chaleur et ventilation pour particuliers et professionnels."
        image="/og-image.jpg"
        url="https://www.tonsite.fr/"
      />

      <StructuredData />

      <Navbar />

      <main>
        <Hero />
        <About />
        <Services />
        <Realisations />
        <Testimonials />
        <Partners />
        <Contact />
      </main>

      <Footer />
    </>
  );
}